/**
 * Ensures the provided value is an array. If the value is not an array, it wraps it in an array.
 *
 * @template T
 * @param {T | T[]} val - The value to ensure as an array.
 * @returns {T[]} - The value wrapped in an array if it was not already an array.
 */

export const ensureArray = (val) => (Array.isArray(val) ? val : [val]);